import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Heart, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-neutral-warm border-t border-gold mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_draped-elegance-2/artifacts/eje53oty_Gemini_Generated_Image_loh71ploh71ploh7-removebg-preview.png" 
                alt="Vastram Logo" 
                className="h-28 w-auto object-contain logo-enhanced"
              />
            </div>
            <p className="text-xs text-gold italic font-light tracking-wide">Rooted in Tradition, Woven with Purpose</p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Every saree tells a story. We celebrate women, tradition, and the timeless elegance of Indian heritage.
            </p>
          </div>

          {/* Shop & Policies */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] text-forest mb-4">Shop</h4>
            <div className="space-y-2">
              <Link to="/products?category=saree" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-sarees">Sarees</Link>
              <Link to="/products?category=suit" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-suits">Suits</Link>
              <Link to="/find-your-saree" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-quiz">Find Your Saree</Link>
              <Link to="/privacy-policy" className="block text-sm text-muted-foreground hover:text-forest transition-colors">Privacy Policy</Link>
              <Link to="/terms-conditions" className="block text-sm text-muted-foreground hover:text-forest transition-colors">Terms & Conditions</Link>
              <Link to="/shipping-policy" className="block text-sm text-muted-foreground hover:text-forest transition-colors">Shipping Policy</Link>
              <Link to="/refund-policy" className="block text-sm text-muted-foreground hover:text-forest transition-colors">Refund Policy</Link>
            </div>
          </div>

          {/* About */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] text-forest mb-4">About</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-about">Our Story</Link>
              <Link to="/drape-stories" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-blog">Drape Stories</Link>
              <Link to="/contact" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-contact">Contact Us</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] text-forest mb-4">Contact</h4>
            <div className="space-y-2">
              <a href="mailto:info@thevastramstore.com" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-email">info@thevastramstore.com</a>
              <a href="tel:+919667881375" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-phone">+91 9667881375</a>
              <a href="https://wa.me/919667881375" target="_blank" rel="noopener noreferrer" className="block text-sm text-muted-foreground hover:text-forest transition-colors" data-testid="footer-whatsapp">WhatsApp</a>
              <p className="text-sm text-muted-foreground">KH-12/17/3, Railway Road,<br/>Delhi-42 (Pin: 110042)</p>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="mt-12 pt-8 border-t border-gold flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} Vastram. Crafted with love for tradition.
          </p>
          <div className="flex space-x-4">
            <a href="https://www.instagram.com/thevastramstore.shop/" target="_blank" rel="noopener noreferrer" className="text-forest hover:text-gold transition-colors" data-testid="social-instagram">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61590643284442" target="_blank" rel="noopener noreferrer" className="text-forest hover:text-gold transition-colors" data-testid="social-facebook">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="https://www.youtube.com/@thevastramstore" target="_blank" rel="noopener noreferrer" className="text-forest hover:text-gold transition-colors" data-testid="social-youtube">
              <Youtube className="w-5 h-5" />
            </a>
            <a href="https://x.com/thevastramstore" target="_blank" rel="noopener noreferrer" className="text-forest hover:text-gold transition-colors" data-testid="social-twitter">
              <Twitter className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Credit */}
        <div className="mt-6 text-center">
          <p className="text-xs text-muted-foreground flex items-center justify-center space-x-1">
            <span>Made with</span>
            <Heart className="w-3 h-3 text-red-500 fill-red-500" />
            <span>by</span>
            <a href="https://www.instagram.com/jhoothout/" target="_blank" rel="noopener noreferrer" className="text-forest hover:text-gold transition-colors font-medium" data-testid="footer-credit-link">@jhoothout</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
